import Footer from 'Footer'
import Loader from 'Loader'
import ScrollToTop from 'ScrollTotop'
import { AdminProfileProvider, SubDomainContext, ProfileProvider, EmployeeDataProvider, UpdatesProvider, ApplicationProvider } from 'context'
import React, { useContext, useEffect } from 'react'
import Home from 'Home'
import LogIn from 'LogIn/management'
import Profile from 'MyProfile'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import Header from 'Header/admin'
import MyApplications from 'MyApplications/management'
import ViewApplication from 'MyApplications/management/viewApplication'
import MyEmployees from 'MyEmployees'
import CreateEmployee from 'MyEmployees/CreateEmployee'
import Updates from 'Updates'
import ViewEmployee from 'MyEmployees/ViewEmployee'
import ForgotPassword from 'ForgotPassword'

export default function App({ subDomain }) {

    const { setSubDomain } = useContext(SubDomainContext)

    useEffect(() => {
        setSubDomain(subDomain)
    }, [subDomain, setSubDomain])

    return (
        <>
            <div className='app-admin' style={{ minHeight: "100vh" }}>
                <BrowserRouter>
                    <ProfileProvider>
                        <AdminProfileProvider>
                            <EmployeeDataProvider>
                                <ApplicationProvider>
                                    <UpdatesProvider>
                                        <Loader />
                                        <ScrollToTop />
                                        <Header />
                                        <Routes>
                                            <Route path="/" element={<Home />} />
                                            <Route path="/login" element={<LogIn />} />
                                            <Route path="/myEmployees/:id" element={<ViewEmployee />} />
                                            <Route path="/createEmployee" element={<CreateEmployee />} />
                                            <Route path="/profile" element={<Profile />} />
                                            <Route path="/myClients/:applicationId" element={<ViewApplication />} />
                                            <Route path="/myClients" element={<MyApplications />} />
                                            <Route path="/myEmployees" element={<MyEmployees />} />
                                            <Route path="/updates" element={<Updates />} />
                                            <Route path="/forgotPassword/:token" element={<ForgotPassword />} />
                                            <Route path="*" element={<Navigate to="/" />} />
                                        </Routes>
                                    </UpdatesProvider>
                                </ApplicationProvider>
                            </EmployeeDataProvider>
                        </AdminProfileProvider>
                    </ProfileProvider>
                </BrowserRouter>
            </div>
            <Footer />
        </>
    )
}
